import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchPets,
  deletePetsData,
  updatePetsList,
  getPetsDetails,
  addPets,
} from "../../apis/pets";

export const fetchPetsData = createAsyncThunk(
  "pets/fetchPets",
  async (
    {
      page,
      pageSize,
      jobId,
      start_dt,
      end_dt,
      type,
    }: {
      page?: number;
      pageSize?: number;
      jobId?: string;
      start_dt?: string;
      end_dt?: string;
      type?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchPets(
        page,
        pageSize,
        jobId,
        end_dt,
        start_dt,
        type
      );
      return {
        data: response?.data, // Extract data properly
        total: response?.total,
      };
    } catch (error: any) {
      console.error("Error fetching pets jobs:", error);
      return rejectWithValue(error.message || "Failed to fetch pets jobs");
    }
  }
);

export const updatePetData = createAsyncThunk(
  "pets/updatePet",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      await updatePetsList(id, data);
      return {
        pets_id: id,
        ...data,
      };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePetData = createAsyncThunk(
  "pets/deletePets",
  async (
    {
      pets_id,
    }: {
      pets_id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deletePetsData(pets_id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPetDetailData = createAsyncThunk(
  "pets/getPetsDetails",
  async (
    {
      pets_id,
    }: {
      pets_id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getPetsDetails(pets_id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const AddPetsData = createAsyncThunk(
  "addPets/addPetsData",
  async ({ job_id }: { job_id?: string }, { rejectWithValue }) => {
    try {
      const response = await addPets(job_id);
      return response; // Ensure a return statement here
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
